import React from 'react';
import './UIErrorView.css';
import {toReadableString} from "../../../../util/utils";
import UIClear from "../Clear/UIClear";
import {PAGE_START, PAGES, USER_ACTION_ERROR_VIEW_OK_CLICKED} from "../../../basic/consts";

class UIErrorView extends React.Component {

    constructor(props) {
        super(props);
        this.copyErrorMessage = this.copyErrorMessage.bind(this);
    }

    componentDidMount() {
        let error = this.props.error;

        if(!error){
            return;
        }

        console.log("error: ", JSON.stringify(error));

        if(error.statusCode === 401){

            // new DataLoader().clearSession();

            setTimeout(() => {

                const path = "/#" + PAGES[PAGE_START].path;
                const host = document.location.host;

                document.location.href = path;

            }, 100);
        }

    }

    copyErrorMessage(){
        const doc = document.getElementById('error-pre');
        if(doc) {

            //
            doc.style.backgroundColor = '#f2f2f2';

            setTimeout(() => {
                doc.style.backgroundColor = '#fff';
            }, 120);

        } else {
            console.error('no doc or clipboard');
        }
    }

    createErrorText(){

        const error     = this.props.error;

        if(!error){
            return "props.error is null";
        }

        const errorInfo = this.props.errorInfo;

        // if(error instanceof ApiInvokerError){
        //     const props = error.props;
        //
        //     try {
        //         if(props['body'] && props['body'].indexOf("password") > 0){
        //             props['body'] = '****';
        //         }
        //     } catch (e){
        //         //
        //     }
        //
        //     return error.message + "<br/>" + toReadableString({
        //         url: error.url,
        //         data: error.props
        //     });
        // }

        if(error instanceof Error){

            let err = error.message;

            if(errorInfo){
                err = err + "<br/><br/>" + JSON.stringify(errorInfo, null, 2).replaceAll("\\n", "<br/>") + "<br/>";
            }

            return err + "<br/>" + error.stack;
        }

        return toReadableString(error);
    }

    render() {
        console.log("render", this.props);

        if(this.props.error.statusCode === 401){
            return <div></div>;
        }

        const errorView = this.createErrorText();

        const style = this.props.marginTop ? {
            marginTop: 0,
            paddingTop: this.props.marginTop,
        } : {};

        return (
            <div className="UIErrorView" style={style}>
                <div className={'UIError-Title'}>
                    <h3>Fehler</h3>
                    <button className={'BasicButton'} onClick={this.copyErrorMessage}>Kopieren</button>
                    <UIClear/>
                </div>
                <pre id={'error-pre'} dangerouslySetInnerHTML={{__html: errorView}}/>

                {this.props.onUserAction && <button className="mdl-button mdl-js-button mdl-button--raised" onClick={ () => { this.onOkClicked()}}>
                    OK
                </button>}
            </div>
        );
    }

    onOkClicked() {
        this.props.onUserAction(USER_ACTION_ERROR_VIEW_OK_CLICKED);
    }
}

export default UIErrorView;
